
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9YmZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b95799731a07c4f7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b95799731a07c4f7$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "P\u0159idat reakci",
    'fabric.reactions.error.unexpected': "Reakce jsou do\u010Dasn\u011B nedostupn\xe9.",
    'fabric.reactions.loading': "Na\u010D\xedt\xe1n\xed...",
    'fabric.reactions.more.emojis': "V\xedce smajl\xedk\u016F",
    'fabric.reactions.other.reacted.users': "{count, plural, one {a\xa0jeden dal\u0161\xed} few {a\xa0{count}\xa0dal\u0161\xed} many {a\xa0{count}\xa0dal\u0161\xedho} other {a\xa0{count}\xa0dal\u0161\xedch}}",
    'fabric.reactions.reactwithemoji': "Reagovat pomoc\xed smajl\xedku {emoji}",
    'fabric.reactions.summary': "Zobrazit v\u0161echny reakce u\u017Eivatel\u016F",
    'reaction-picker-trigger.add.reaction.message': "P\u0159idat reakci",
    'reactions.dialog.close': "Zav\u0159\xedt",
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Navigace doleva',
    'reactions.dialog.reactions.count': "{count, plural, one {{count,number} reakce celkem} few {{count,number} reakce celkem} many {{count,number} reakce celkem} other {{count,number} reakc\xed celkem}}",
    'reactions.dialog.right.navigate': 'Navigace doprava',
    'reactions.dialog.viewall': "Zobrazit v\u0161e",
    'reactions.dialog.viewall.tooltip': "Zobrazit v\u0161echny reakce u\u017Eivatel\u016F"
};

});


//# sourceMappingURL=cs.c861fe0d.js.map
